import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import RADEnvironmentProxy from '@/Communication/RADEnvironmentProxy';
import EventHelper from '@/Utility/EventHelper';
import FileUploadViewModel from '@/ViewModels/Controls/FileUploadViewModel';
import FileUpload from '@/Controls/FileUpload';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';

export default class EmbeddedMediumBoxFactory extends ControlFactory {

    private jQueryControl: JQuery;
    private FileUploadViewModel = ComponentManager.getViewModel<typeof FileUploadViewModel>('FileUploadViewModel');
    private FileUpload = ComponentManager.getControl<typeof FileUpload>('FileUpload');
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');

    private technicalNameRootProperty: string;
    private technicalNameFilename: string;
    private technicalNameFileLength: string;
    private technicalNameUploadedFile: string;

    public thumbWidth: number;
    public thumbHeight: number;
    public preview: string;
    public scaleSmallThumb: boolean;
    public fileFilter: any;
    public isDropable: boolean;

    /**
     * @override
     */
    public viewModel: FileUploadViewModel;

    public constructor(private params: any) {
        super(params);
        this.technicalNameRootProperty = '';
        this.technicalNameFilename = '';
        this.technicalNameFileLength = '';
        this.technicalNameUploadedFile = '';

        this.thumbWidth = this.paramOrDefault(this.params.thumbWidth, 423, this.parseThumbDimension);
        this.thumbHeight = this.paramOrDefault(this.params.thumbHeight, 423, this.parseThumbDimension);

        this.preview = this.paramOrDefault(this.params.preview, 'Popup');
        this.scaleSmallThumb = this.paramOrDefault(this.params.scaleSmallThumb, false);
        this.fileFilter = this.paramOrDefault(this.params.fileFilter, null);
        this.isDropable = this.paramOrDefault(this.params.isDropable, false);
    }

    /**
     * @override
     */
    control: FileUpload;

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = this.createViewModel();

        this.control = new this.FileUpload(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        this.registerObservableValidation(this.viewModel.file);
        this.registerCustomValidation([this.detailViewItem.name], this.viewModel.file, this.filterTypeValidation.bind(this));

        return this.jQueryControl;
    }

    private createViewModel(): FileUploadViewModel {
        this.validateTechName();
        
        return new this.FileUploadViewModel({
            factory: this,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            parentLocator: this.locator,
            locator: this.technicalNameRootProperty,
            isValid: this.isValid,
            isSummaryViewMode: this.isSummaryViewMode,
            isFocusable: this.isFocusable,
            thumbWidth: this.thumbWidth,
            thumbHeight: this.thumbHeight,
            previewMode: this.preview,
            scaleSmallThumb: this.scaleSmallThumb,
            fileFilter: this.fileFilter,
            name: this.context.genericObject.getObservable(this.technicalNameFilename),
            size: this.context.genericObject.getValue(this.technicalNameFileLength),
            techName: this.context.genericObject.getObservable(this.technicalNameUploadedFile),
            invalidationText: this.invalidationText,
            pdoId: this.context.genericObject.pdoId,
            lockGroupId: this.context.getLockGroupId(),
            attributeName: this.technicalNameRootProperty,
            isDropable: this.isDropable,
            tooltip: new this.LabelViewModel({
                ergName: this.detailViewItem.tooltip
            }),
            onChange: (file: any) => {
                this.context.genericObject.isModified(true);
            }
        });
    }

    private validateTechName(): void {
        this.technicalNameRootProperty = this.detailViewItem.name;

        if (this.detailViewItem.name.substring(this.detailViewItem.name.length - 6) === '.Value') {
            this.technicalNameRootProperty = this.detailViewItem.name.substring(0, this.detailViewItem.name.length - 6);
        }

        this.technicalNameFilename = this.technicalNameRootProperty + '.Filename';
        this.technicalNameFileLength = this.technicalNameRootProperty + '.FileLength';
        this.technicalNameUploadedFile = this.technicalNameRootProperty + '.UploadedFile';
    }

    private filterTypeValidation(file: File): boolean {
        if (!this.viewModel.isRequired() && (!file || file.name === '')) // Kein Pflichtfeld
            return true;

        if (this.viewModel.fileFilter && file && file.name) {
            let allowedTypes = this.viewModel.fileFilter.split(',');
            let fileType = file.name.slice(file.name.lastIndexOf('.'));
            let fileTypeLowerCase = fileType.toLowerCase();

            if (_.contains(allowedTypes, fileTypeLowerCase)) {
                return true;
            }
        } else if (file && file.name) { // Leerer Filter erlaubt alle Typen
            return true;
        }

        return false;
    }

    private parseThumbDimension(val: string, def: any): number {
        let ret = parseInt(val);
        if (isNaN(ret)) {
            return def;
        }

        return ret;
    }
}

ComponentManager.setFactory('EmbeddedMediumBox', EmbeddedMediumBoxFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');